"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const contentFeeds_1 = require("./contentFeeds");
const emailCampaigns_1 = require("./emailCampaigns");
const emailTemplateBlocks_1 = require("./emailTemplateBlocks");
const users_1 = require("./users");
exports.emailDetailData = (includeDefaultContentFeedInEmailQuery = true) => graphql_tag_1.default `
  fragment emailDetailData on Email {
    id
    name
    html
    latestSubjectLines
    originalHTML
    createdAt
    updatedAt
    emailNumber
    resourceUrl
    ${includeDefaultContentFeedInEmailQuery
    ? `defaultContentFeedSecond {
      ...contentFeedDetailData
    }`
    : ''}
    assignedUsers {
      ...basicUserDetailData
    }
    metaCampaign {
      ...emailCampaignDetailData
    }
    blocks {
      ...emailTemplateBlockDetails
    }
    emailTemplateVersion {
      id
      version
      createdAt
      html
      releaseNotes
      template {
        id
        name
        productionVersion {
          id
          createdAt
          version
          screenshot {
            id
            url
          }
        }
        stagingVersion {
          id
          createdAt
          version
        }
      }
    }
  }
  ${emailTemplateBlocks_1.emailTemplateBlockDetails}
  ${includeDefaultContentFeedInEmailQuery ? contentFeeds_1.contentFeedDetailData : ''}
  ${emailCampaigns_1.emailCampaignDetailData}
  ${users_1.basicUserDetailData}
`;
//# sourceMappingURL=emails.js.map